import { Metadata } from "next";
import Skeleton from "@mui/material/Skeleton";

export const metadata: Metadata = {
  title: "Loading - HTU",
};

export default function Loading() {
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  return (
    <div className="loading">
      <Skeleton variant="rectangular" height={480} />
      <div className="container mt-70 mb-70">
        <Skeleton variant="text" animation="wave" />
        <Skeleton variant="text" animation="wave" />
        <Skeleton variant="text" animation="wave" />
        <Skeleton variant="text" animation="wave" />
        <Skeleton variant="text" animation="wave" />
        <Skeleton variant="text" animation="wave" />
        <Skeleton variant="text" animation="wave" />
        <div className="d-flex flex-row mt-40">
          <Skeleton
            variant="rectangular"
            height={55}
            width={190}
            className="loading-margin"
          />
          <Skeleton variant="circular" width={55} height={55} />
        </div>
      </div>
      <Skeleton variant="rectangular" height={isMobile ? 255 : 374} />
    </div>
  );
}
